import Activity from "./Activity";
import Notifications from "./Notifications";
import Counts from "./Counts";
import Analytics from "./Analytics";

export default {
  Activity,
  Notifications,
  Counts,
  Analytics
};
